module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4gwZCAsYgTL1GAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAMSURBVAjXY6isrAQAAtoBbJ4In94AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/black.png
// module id = RPLP
// module chunks = 32